<template>
  <el-dialog
  class="ModalShareKc"
  :show-close="true"
  :visible="visible"
  :before-close="handleClose">
    <div
    slot="title"
    class="ModalShareKc__header">
      <span class="ModalShareKc__title">Send to KingsChat Contact</span>
    </div>
    <div
    v-if="file.shareLink"
    class="ModalShareKc__body">
      <input
      type="text"
      placeholder="Search by name"
      v-model="filter"
      class="ModalShareKc__filter">
      <transition-group
      tag="div"
      class="ModalShareKc__results scrollbar-container"
      appear
      name="fade-in"
      mode="out-in">
        <ContactBar
        v-for="contact in filterContacts"
        :key="contact.userId"
        :contact="contact"
        :sent="isSent(contact.userId)"
        :failed="isFailed(contact.userId)"
        @sendMessage="sendMessage(contact.userId)"
        class="ModalShareKc__contact"/>
      </transition-group>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ContactBar from './ContactBar/ContactBar.vue'

export default {
  name: 'ModalShareKc',

  components: {
    ContactBar
  },

  data () {
    return {
      filter: '',
      sent: {}
    }
  },

  computed: {
    ...mapGetters('modal', [
      'fileByModal',
      'visibleByModal'
    ]),
    ...mapGetters('user', [
      'contacts',
      'user'
    ]),
    file () {
      return this.fileByModal('shareKc')
    },
    visible () {
      return this.visibleByModal('shareKc')
    },
    filterContacts () {
      return this.filter ? this.contacts.filter(cont => {
        return cont.contactName.toLowerCase().includes(this.filter.toLowerCase())
      }) : this.contacts
    }
  },

  watch: {
    visible () {
      this.filter = ''
      this.sent = {}
      this.failed = {}
    }
  },

  methods: {
    ...mapActions('modal', [
      'hideModal'
    ]),
    ...mapActions('message', [
      'sendSingleMessage'
    ]),
    handleClose () {
      this.hideModal('shareKc')
    },
    sendMessage (userId) {
      const text = `@${this.user.username} shared a file with you: ${this.file.shareLink}`
      const payload = {
        text,
        userId
      }
      this.sendSingleMessage(payload)
        .then((result) => {
          this.sent[userId] = true
          this.$forceUpdate()
        }).catch(() => {
          this.failed[userId] = true
          this.$forceUpdate()
        })
    },
    isSent (userId) {
      return this.sent[userId] || false
    },
    isFailed (userId) {
      return this.failed[userId] || false
    }
  }
}
</script>

<style lang="scss">
@import 'ModalShareKc';
</style>
